export default class DashboardDateRangeValidity {

    static isValid(fromDate, toDate) {
        return !!fromDate?.isValid?.() && !!toDate?.isValid?.() && !fromDate.isAfter(toDate);
    }
}
